module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Tabs', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "on-click": _vm.handleTapChange
    },
    model: {
      value: (_vm.tabsValue),
      callback: function($$v) {
        _vm.tabsValue = $$v
      },
      expression: "tabsValue"
    }
  }, _vm._l((_vm.contentType), function(item, index) {
    return _c('TabPane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.name
      }
    })
  }), 1), _vm._v(" "), _c('el-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabsValue == '制作音视频内容' || _vm.tabsValue == '查看音视频内容'),
      expression: "tabsValue == '制作音视频内容' || tabsValue == '查看音视频内容'"
    }]
  }, [_c('addBookContent', {
    attrs: {
      "contentInfo": _vm.contentInfo,
      "doWhatTemp": _vm.doWhatTemp
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabsValue == '制作电子书内容' || _vm.tabsValue == '查看电子书内容'),
      expression: "tabsValue == '制作电子书内容' || tabsValue == '查看电子书内容'"
    }]
  }, [_c('PreviewBar', {
    attrs: {
      "book": _vm.book,
      "currIndex": _vm.currIndex,
      "doWhat": _vm.doWhatTemp,
      "pdfChgMode": _vm.chgMode
    },
    on: {
      "update:book": function($event) {
        _vm.book = $event
      },
      "update:currIndex": function($event) {
        _vm.currIndex = $event
      },
      "update:curr-index": function($event) {
        _vm.currIndex = $event
      },
      "previewHandle": _vm.previewHandler,
      "update:pdfChgMode": function($event) {
        _vm.chgMode = $event
      },
      "update:pdf-chg-mode": function($event) {
        _vm.chgMode = $event
      }
    }
  }), _vm._v(" "), (_vm.showEditPanel) ? _c('PointInteract', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "doWhatTemp": _vm.doWhatTemp,
      "contentInfo": _vm.contentInfo,
      "pointEditor": _vm.formForBasicInfo,
      "ind": _vm.pointIndex,
      "doWhat": _vm.doWhatTemp
    },
    on: {
      "update:pointEditor": function($event) {
        _vm.formForBasicInfo = $event
      },
      "update:point-editor": function($event) {
        _vm.formForBasicInfo = $event
      },
      "backToEdit": _vm.pointBackToEdit
    }
  }) : _vm._e()], 1), _vm._v(" "), (this.$route.query.do == 'edit') ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 4px"
    },
    on: {
      "click": function($event) {
        return _vm.doupStep2('formCustom2')
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.do == 'view') ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 4px"
    },
    on: {
      "click": function($event) {
        return _vm.doupStep3('formCustom3')
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (this.$route.query.do == 'edit') ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 0"
    },
    on: {
      "click": function($event) {
        return _vm.doNextStep('formCustom')
      }
    }
  }, [_vm._v("确定")]) : _vm._e(), _vm._v(" "), (this.$route.query.do == 'view') ? _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "20px 0"
    },
    on: {
      "click": function($event) {
        return _vm.doNextStep1('formCustom1')
      }
    }
  }, [_vm._v("确定")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59dbe37d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/addContent.vue
// module id = 698
// module chunks = 1